import type { ToneOverlay } from "../index.js";

// "Dark"-Stimme auf Deutsch: trockener Galgenhumor — deadpan, sarkastisch, bürokratisch
// präzise. Eigener Humor, keine Übersetzung. Optional; die ernste Stimme bleibt Standard.
// Zeilen mit Varianten rotieren alle zwei Stunden (TONE_ROTATE_MS). Jede Variante behält
// die {Platzhalter} des Basistexts.
export const overlay: ToneOverlay = {
  "alert.toast.new": [
    "{hazard} in der Nähe. Na super.",
    "{hazard} in der Nähe. Läuft.",
    "{hazard} in der Nähe. Typisch.",
    "{hazard} in der Nähe. Sag im Familienchat Bescheid.",
    "{hazard} in der Nähe. Wie schön.",
  ],
  "alert.toast.escalation": [
    "{hazard} ist schlimmer geworden. Wie geplant.",
    "{hazard} eskaliert. Sehr effizient.",
    "{hazard} legt zu. Na klar.",
    "{hazard} verschlimmert sich. Ordnungsgemäß.",
  ],
  "alert.toast.inPath": [
    "{hazard} kommt direkt zu dir. Lauf.",
    "{hazard} hat dich ausgewählt. Glückwunsch. Geh.",
    "{hazard} kommt auf dich zu. Heute nicht, danke. Beweg dich.",
    "{hazard} mit deinem Namen drauf. Verschwinde.",
  ],
  "alert.toast.allClear": [
    "Noch am Leben bei {place}. Immerhin.",
    "{place} hat dich nicht erwischt. Diesmal.",
    "{place} überlebt. Kommt in die Akte.",
    "Alles ruhig bei {place}. Bis zum nächsten Mal.",
  ],
  "alert.toast.tap": [
    "Tippen für den Plan, nicht das Zeitliche zu segnen.",
    "Tippen. Hier steht, wie man am Leben bleibt.",
    "Tippen. Die Atem-Anleitung ist drin.",
  ],
  "alert.takeover.title": [
    "{hazard} — heute hast du die Hauptrolle. Los.",
    "{hazard} — die Szene, in der man rennt. Lauf.",
    "{hazard} — erst handeln, beschweren später.",
  ],
  "alert.takeover.details": "Die düsteren Einzelheiten",
  "alert.takeover.dismiss": "Überlebt, schließen",
  "now.status.allClear": [
    "Noch da. Sieh an.",
    "Noch am Atmen. Immerhin etwas.",
    "Statistisch gesehen okay.",
    "Ruhig. Verdächtig ruhig.",
    "Lebendig und gelangweilt. Optimal.",
    "Keine Vorkommnisse. Vorerst.",
    "Weder noch. Perfekt.",
  ],
  "now.status.stayAware": [
    "Augen auf, man weiß ja nie.",
    "Trau nicht mal deinem Schatten.",
    "Ein Auge offen, sicherheitshalber.",
    "Das ist der ruhige Teil. Genieß ihn.",
    "Werd bloß nicht leichtsinnig.",
    "Behalt's im Auge, nicht dass noch was kommt.",
  ],
  "now.status.sub.allClear": [
    "Nichts will dich umbringen im Radius. Wunder.",
    "Keine Gefahren in der Nähe. Trau dem Frieden nicht.",
    "Der Radius ist sauber. Vorerst.",
    "Nichts auf dem Schirm. Genieß es, solange es hält.",
    "Alles ruhig. Zu ruhig.",
    "Nichts in Sicht. Das Universum ist abgelenkt.",
  ],
  "now.activity.empty": [
    "Verdächtig ruhig, ja.",
    "Nichts. Schon fast unhöflich.",
    "Hier ist tote Hose.",
    "Keine Menschenseele. Grillen.",
    "Null Meldungen. Tun wir, als wär's gut.",
    "Stille. Schlechtes Omen, aber Stille.",
  ],
  "onboarding.promise.tagline": "Nachbarn halten Nachbarn am Leben.",
  "onboarding.promise.continue": "Dann mal überleben",
  "onboarding.home.browse": "Nur kurz die Apokalypse begutachten",
  "you.voice.intro": "Wähle dein Lieblingsformat für schlechte Nachrichten.",
};
